import { confirmAlert } from "react-confirm-alert";
import { Box } from "@mui/material";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { FxButton } from "../button/FxButton";

export const ConfirmAction = (props: any) => {
    const { message, item, okAction } = props;

    const onClickYes = async (onClose: any) => {
        await okAction(item);
        onClose();
    }

    confirmAlert({
        customUI: ({ onClose }: any) => {
            return (
                <div className='react-confirm-alert-body react-confirm-alert-custom-ui'>
                    <Box>
                        <Box sx={{ backgroundColor: "primary.main", color: "#fff", display: "flex", justifyContent: "space-between", alignItems: "center", py: 1, px: 2.5, borderRadius: "10px 10px 0px 0px" }}>
                            <Box sx={{ fontWeight: 600, fontSize: "15px", pl: 1 }}>Confirm</Box>
                            <Box sx={{ cursor: "pointer" }} onClick={onClose}>
                                <HighlightOffIcon />
                            </Box>
                        </Box>
                        <Box sx={{ m: 2 }}>
                            <Box sx={{ py: 2, fontSize: "16px" }}>
                                {message}
                            </Box>
                            <Box sx={{ display: "flex", justifyContent: "end" }}>
                                <FxButton label="No" color="inherit" className="button-style" variant="contained" onClick={onClose} />
                                <FxButton label="Yes" variant="contained" className="button-style" sx={{ ml: 2 }} onClick={() => onClickYes(onClose)} />
                            </Box>
                        </Box>
                    </Box>
                </div>
            );
        }
    });
};